import React, { ReactNode } from 'react';
import Image from '@atlaskit/image';
import { Success, Warning, Error } from '../../assets';
import { MessageType } from '../../common/Types';
import { Container, IconWrapper, Content, Header, Body } from './ToastContent.styles';

type Props = {
  header?: string;
  body: ReactNode;
  type: MessageType;
};

const ToastContent: React.FC<Props> = ({ header, body, type }) => {
  const icon = () => {
    if (type === MessageType.SUCCESS) {
      return <Image src={Success} alt="success" />;
    }
    if (type === MessageType.WARNING) {
      return <Image src={Warning} alt="warning" />;
    }
    if (type === MessageType.ERROR) {
      return <Image src={Error} alt="error" />;
    }
  };
  return (
    <Container>
      <IconWrapper>{icon()}</IconWrapper>
      <Content>
        {header && <Header>{header}</Header>}
        <Body>{body}</Body>
      </Content>
    </Container>
  );
};

export default ToastContent;
